module.exports = __webpack_public_path__ + "img/member-photo-default.25e67974.svg";